module.exports = __webpack_public_path__ + "img/history7.4564c30b.jpg";